import React from "react";
import LoadingIcon from "../LoadingIcon";
import { Link } from "react-router-dom";

const OffsetButton = ({
    children,
    color = "FrenchRed",
    borderColor = "border-teal-500",
    textColor = "text-white",
    className = "",
    hoverEffect = "hover:bg-teal-700",
    type = "offset",
    isLoading = false,
    isDisabled = false,
    onClick = null,
    reversed = false,
    icon = null,
    ...props
}) => {
    if (!className.includes("bg")) {
        if (color === "FrenchRed") {
            className += ` bg-FrenchRed-500  dark:bg-FrenchRed-500 outline-FrenchRed-500 dark:border-FrenchRed-600 hover:bg-opacity-0 dark:hover:bg-opacity-0 hover:text-FrenchRed-500 dark:hover:text-FrenchRed-500 clr-white`;
        } else if (color === "rose") {
            if (reversed) {
                className += ` bg-rose-500 border-rose-500 dark:bg-rose-500 dark:border-rose-500 hover:bg-opacity-100 dark:hover:bg-opacity-100 dark:bg-opacity-0 bg-opacity-0 text-rose-500 dark:hover:text-rose-500 hover:text-slate-50 dark:hover:text-slate-50`;
            } else {
                className += ` bg-rose-500 border-rose-500 dark:bg-rose-500 dark:border-rose-500 hover:bg-opacity-0 dark:hover:bg-opacity-0 dark:bg-opacity-100 bg-opacity-100 hover:text-rose-500 dark:hover:text-rose-500 clr-white`;
            }
        } else if (color === "earthYellow") {
            className += ` bg-earthYellow-300 rounded-none dark:bg-earthYellow-500 outline-earthYellow-300 font-w-bold dark:outline-earthYellow-600 text-earthYellow-950`;
        } else if (color === "germanRed") {
            className += ` bg-germanRed-700 rounded-none dark:bg-germanRed-500 outline-germanRed-300 font-w-bold dark:outline-germanRed-600 text-germanRed-50`;
        } else if (color === "ashGray") {
            className += ` bg-ashGray-500 dark:bg-ashGray-500 outline-ashGray-600 rounded-none font-w-bold dark:outline-ashGray-600 text-ashGray-100`;
        }
    }
    return (
        <>
            <Link
                onClick={onClick}
                type={type}
                className={`relative   rounded-xl ${
                    type === "offset" && "outline outline-offset-4 hover:outline-offset-0"
                } inline-flex  items-center justify-center px-6 py-3 ${
                    isLoading ? "opacity-50 cursor-not-allowed" : ""
                } ${isDisabled ? "opacity-50 cursor-not-allowed" : ""} smooth ${className}`}
                disabled={isDisabled || isLoading ? true : false}
                {...props}
            >
                {isLoading ? (
                    <LoadingIcon />
                ) : (
                    <>
                        {children}
                        {icon && <img src={icon} alt="Icon" className="ml-2 w-5 h-5" />}
                    </>
                )}
            </Link>
        </>
    );
};

export default OffsetButton;
